module.exports = __webpack_public_path__ + "img/chatbot.082ca5fe.svg";